import { platformApi } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useSubjects(type, groupType, groupCodes = [], filter = {}) {
  const queryKey = ['subjects', type, groupType, groupCodes, filter];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      log('Read', 'Subjects', { type, groupType, groupCodes, filter });

      const searchParams = new URLSearchParams([
        ['type', type],
        ...Object.entries(filter).map(([key, value]) => [key, value]),
        ['groupType', groupType],
        ...groupCodes.map((code) => ['groupCodes', code]),
      ]);
      return platformApi.get('subjects', { searchParams, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
